import { render } from "./TileAdminProjects.vue?vue&type=template&id=40dff2fe&scoped=true&ts=true"
import script from "./TileAdminProjects.vue?vue&type=script&lang=ts"
export * from "./TileAdminProjects.vue?vue&type=script&lang=ts"

import "./TileAdminProjects.vue?vue&type=style&index=0&id=40dff2fe&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40dff2fe"]])

export default __exports__